import { ticketsListModel } from '../../entities/ticketsList/model';
import { TicketsFilters, TicketsTable } from '@acme/features';
import { PaginatedContent } from '@acme/foundation';
import { useUnit } from 'effector-react';
import { Alert } from 'flowbite-react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export function TicketsListPage() {
  const navigate = useNavigate();

  const {
    filteredItems,
    totalCount,
    pageNumber,
    pageSize,
    isLoading,
    error,
    filters,
    onListOpened,
    onFiltersChanged,
    onPageChanged,
  } = useUnit({
    filteredItems: ticketsListModel.$filteredItems,
    totalCount: ticketsListModel.$totalCount,
    pageNumber: ticketsListModel.$pageNumber,
    pageSize: ticketsListModel.$pageSize,
    isLoading: ticketsListModel.$isLoading,
    error: ticketsListModel.$error,
    filters: ticketsListModel.$filters,
    onListOpened: ticketsListModel.listOpened,
    onFiltersChanged: ticketsListModel.filtersChanged,
    onPageChanged: ticketsListModel.pageChanged,
  });

  useEffect(() => {
    onListOpened();
  }, [onListOpened]);

  const handleRowClick = (ticketId: string) => {
    navigate(`/support/tickets/${ticketId}`);
  };

  const displayCount = filters.search.trim()
    ? `${filteredItems.length} из ${totalCount}`
    : totalCount;

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h1 className="text-2xl font-semibold text-gray-900">
          Обращения
          {!!totalCount && (
            <span className="ml-2 text-base font-medium text-gray-500">
              ({displayCount})
            </span>
          )}
        </h1>
      </div>

      <TicketsFilters
        value={filters}
        onChange={onFiltersChanged}
        searchPlaceholder="Поиск по номеру, теме, категории…"
      />

      {error && (
        <Alert color="failure">
          <span className="font-medium">Ошибка!</span> {error}
        </Alert>
      )}

      {!isLoading && (
        <PaginatedContent
          pageNumber={pageNumber}
          pageSize={pageSize}
          totalCount={totalCount}
          onPageChange={onPageChanged}
        >
          <TicketsTable tickets={filteredItems} onRowClick={handleRowClick} />
        </PaginatedContent>
      )}
    </div>
  );
}
